export default (
  <svg width="24" height="6" viewBox="0 0 24 6" fill="none" xmlns="http://www.w3.org/2000/svg" color={'inherit'}>
    <circle cx="3.375" cy="3" r="2.875" transform="rotate(-90 3.375 3)" fill="currentColor" />
    <circle cx="12" cy="3" r="2.875" transform="rotate(-90 12 3)" fill="currentColor" />
    <circle cx="20.625" cy="3" r="2.875" transform="rotate(-90 20.625 3)" fill="currentColor" />
  </svg>
);
